import { useGeoIP } from '@hc-frontend/core-ui';
import React from 'react';

export interface UnbounceZipCodeFieldProps {
  title: string;
  subtitle: string;
  buttonCta: string;
  popUnderUrl: string;
  popOutUrl?: string;
  alwaysStack?: boolean;
}

export default function UnbounceZipCodeField(
  props: Readonly<UnbounceZipCodeFieldProps>,
) {
  const location = useGeoIP();
  const zipCode = location?.zipCode || '';
  const [error, setError] = React.useState<boolean>(zipCode.length !== 5);
  const [inputZipCode, setInputZipCode] = React.useState(zipCode);

  return (
    <div className="my-[20px] p-[20px] font-family-inherit">
      <h4 className="font-bold text-2xl mb-[5px]">{props.title}</h4>
      <h5
        className="text-md mb-[10px]"
        dangerouslySetInnerHTML={{ __html: props.subtitle }}
      ></h5>
      <div
        className={`flex flex-col ${props.alwaysStack ? 'tablet:flex-col' : 'tablet:flex-row'}`}
      >
        <input
          type="number"
          className={`text-lg mr-[10px] w-full [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none border ${error ? '[border-color:red]' : '[border-color:green]'} rounded-md px-[27px] py-[5px] mr-2`}
          maxLength={5}
          defaultValue={zipCode}
          placeholder="Enter Zip Code"
          onChange={(e) => {
            setError(false);
            setInputZipCode(e.target.value);
          }}
        />
        <button
          className={`transition-all mt-[10px] w-full ${props.alwaysStack ? 'tablet:mt-[10px]' : 'tablet:mt-0'} bg-secondary-900 hover:bg-secondary-950 rounded-md px-[27px] py-[5px] !text-[black] font-semibold text-lg`}
          onClick={() => {
            if (inputZipCode.length !== 5) {
              setError(true);
              return;
            }
            const popUnderUrl = props.popUnderUrl.replace(
              '{{zipCode}}',
              inputZipCode,
            );
            window.open(popUnderUrl, '_self');
            if (props.popOutUrl) {
              const popOutUrl = props.popOutUrl.replace(
                '{{zipCode}}',
                inputZipCode,
              );
              window.open(popOutUrl, '_blank');
            }
          }}
        >
          {props.buttonCta}
        </button>
      </div>
      {error && (
        <p className="text-[red] mt-[5px]">
          Please enter a valid 5-digit zip code.
        </p>
      )}
    </div>
  );
}
